import { EDITOR_LAYERING } from "@pathwright/blocks-engine"
import Button from "@pathwright/ui/src/components/button/Button"
import styled from "styled-components"

const DeleteBlockPromptWrapper = styled.div`
  text-align: center;
  position: absolute;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  min-height: 40px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  z-index: ${EDITOR_LAYERING.DELETE_PROMPT};
  border: 1px solid rgba(255, 255, 255, 0.3);
`

const DeleteBlockPromptButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const DeleteBlockPrompt = (props) => {
  const { onDelete, onCancel } = props

  return (
    <DeleteBlockPromptWrapper>
      <DeleteBlockPromptButtons>
        <Button styleType="primary" onClick={onDelete} dangerous>
          Confirm Delete
        </Button>
        <Button
          styleType="blank"
          inverted
          className="Cancel"
          onClick={onCancel}
          style={{ marginLeft: "auto" }}
        >
          Cancel
        </Button>
      </DeleteBlockPromptButtons>
    </DeleteBlockPromptWrapper>
  )
}

export default DeleteBlockPrompt
